import { render } from "./story_row.vue?vue&type=template&id=1ef24ae6&scoped=true&lang=pug"
import script from "./story_row.vue?vue&type=script&lang=js"
export * from "./story_row.vue?vue&type=script&lang=js"

import "./story_row.vue?vue&type=style&index=0&id=1ef24ae6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef24ae6"]])

export default __exports__